import { Component, OnInit, Inject } from "@angular/core";
import { LoaderService } from "./shared/services/loader/loader.service";
import { DOCUMENT } from "@angular/common";
import { PaymentTransactionService } from "./shared/services/payment-transaction/payment-transaction.service";
import { SignalrService } from "./shared/services/signalr/signalr.service";
import { DirectDebitInfo } from "./shared/constants/information-modal.constant";
import { PayzenService } from "./shared/services/payzen/payzen.service";
import { environment } from "../../src/environments/environment";
import { Router } from "@angular/router";
import { RoutePath } from "./shared/constants/globals.constant";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  public showDirectDebit = false;
  public directDebitInfo = DirectDebitInfo;
  firstLoad = true;
  constructor(
    @Inject(DOCUMENT) private document: any,
    private loaderService: LoaderService,
    //  private applicationInsightsService: ApplicationInsightsService
    private paymentTransactionService: PaymentTransactionService,
    private signalrService: SignalrService,
    private payzenService: PayzenService,
    private router: Router
  ) {}

  ngOnInit() {
    // TODO: Delete all between this...
    // this.applicationInsightsService.logTrace('Probando el "LogTrace" 3');
    // this.applicationInsightsService.logEvent('Se inicio el unsubscribe "LogEvent" 3');
    // this.applicationInsightsService.logMetric('Metrica desde unsubscribe "LogMetric" 3', 4);
    // this.applicationInsightsService.logPageView('Log de pagina "LogPageView" 3');
    // this.applicationInsightsService.logException(new Error('El error para oscar'), 4);
    // TODO: and this.
    this.loaderService.connection.subscribe((online: boolean) => {
      if (online) {
        this.document.body.classList.remove("app--connection-lost");
      } else {
        this.document.body.classList.add("app--connection-lost");
      }
    });
    const transaction = this.paymentTransactionService.getCacheTransaction();
    if (transaction) {
      this.signalrService.startConnection(transaction.id);
      console.log("SignalR connection started from AppComponent");
    }
    this.payzenService.verifyDirectDebit$.subscribe(() => {
      if (this.firstLoad) {
        this.virifyDirectDebit();
        this.firstLoad = false;
      }
    });
  }

  public virifyDirectDebit() {
    const transaction = this.paymentTransactionService.getCacheTransaction();

    this.payzenService
      .verifyDirectDebit(
        transaction.payments[0].buildingExpense.electronicPaymentCode
      )
      .subscribe(
        (response) => {
          if (response.applies) {
            if (response.nextDueDate == null) {
              this.directDebitInfo.body = `El código de pago electrónico está adherido a débito automático.`;
            } else {
              this.directDebitInfo.body = `El código de pago electrónico está adherido a débito automático, el próximo ${response.nextDueDate} se ejecutará el débito`;
            }
            this.showDirectDebit = true;
          }
          this.loaderService.hideLoader();
        },
        (error) => {
          if (!environment.production) console.log(error);
          this.loaderService.hideLoader();
        }
      );
  }
  public closeModalDirectDebit(event): void {
    this.paymentTransactionService.removeCacheTransaction();
    this.paymentTransactionService._adminPlatform = false;
    this.showDirectDebit = false;
    this.router.navigate([RoutePath.initPayment]);
  }
}
